module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat4@2x-c6f93af23c8fd9fc946f7fd9b91bade5.jpg";